export default "__VITE_ASSET__BiK1eYE2__"